const statuses = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Pending',
    value: 'Pending',
  },
  {
    label: 'Rejected',
    value: 'Rejected',
  },
  {
    label: 'Cancelled',
    value: 'Cancelled',
  },
];

export default statuses;
